export const pggaDataSources = [
  {
    title: 'Lesson Learned',
    content:
      ' Library of learnings capturing experience that is important enough to be communicated across the business. It can be related to positive findings (Good Practice), i.e., events that have gone well and had a significant positive impact on the way we operate, or negative findings, i.e., events that have resulted in significant non-value add activity that must be removed to prevent reoccurrence',
    sourceSystem: null,
    prompts: [
      'Show me learnings related to Project Management?',
      'Show me learnings related to Engineering?',
      'Show me leanings related to Sales and Tendering?'
    ],
    datasourcelink: ''
  },
  {
    title: 'PGGA Product Documents (xECM)',
    content: `Akira has access to PGGA product documentation stored in xECM. This enables users to quickly understand the project portfolio, product capabilities, and key features without navigating complex document repositories. \nAkira ensures PGGA employees receive the right product information at the right time, eliminating the need for manual searches across multiple systems.\n\n**Important Notes on Product Documents**\nOnly the latest subversions of products are considered.\nAlways specify the product version and name to receive accurate responses.\n\n**Known Limitations**\nAkira does not currently differentiate between product subversions.\nAkira may not reliably identify the specific version in which a feature was introduced.`,
    sourceSystem: null,
    prompts: [
      'What kind of devices does the SuprOS network management platform support?',
      'How do I configure secure communication via IEC60870-5-104 to a remote control center?'
    ],
    datasourcelink: ''
  },
  {
    title: 'PGGA Process Documents (xECM and OneView)',
    content:
      ' Akira provides information from PGGA process documentation available in xECM. This helps users understand PGGA‑specific processes, policies, and guidelines, and obtain clarifications without manually reviewing process documents.',
    sourceSystem: null,
    prompts: [
      'How many Project Reviews are required for projects above 2M USD?',
      'Who is responsible for process governance in BU PGGA?'
    ],
    datasourcelink: ''
  },
  {
    title: 'GPP and SAP Training Manuals',
    content: ` GPP and SAP (Project Cockpit) are the primary systems used for project management. Akira has access to official training manuals, instructions, and guidelines for these tools.\n\nUsers can ask Akira how to perform various project management activities, including planning, execution, monitoring, and reporting. All PM training materials are available to support consistent and efficient project management practices.`,
    sourceSystem: null,
    prompts: ['How do I book a project in SAP/GPP?', 'How do I manage risks and opportunities in SAP or GPP?'],
    datasourcelink: ''
  }
]
